import { render, staticRenderFns } from "./wqBooks.vue?vue&type=template&id=d27cfa80&scoped=true&"
import script from "./wqBooks.vue?vue&type=script&lang=js&"
export * from "./wqBooks.vue?vue&type=script&lang=js&"
import style0 from "./wqBooks.vue?vue&type=style&index=0&id=d27cfa80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d27cfa80",
  null
  
)

export default component.exports